module.exports = __webpack_public_path__ + "img/EventslyColored.63db54dd.png";